import { NzTableFilterList } from 'ng-zorro-antd/table';
import {
    MigrationSnipeStatusEnum,
    MigrationSnipeWizardStepEnum,
} from '../../migration-sniper.interfaces';

type FilterOption = 'status' | 'step';

export const FILTER_OPTIONS: Record<FilterOption, NzTableFilterList> = {
    status: [
        {
            text: 'Active',
            value: MigrationSnipeStatusEnum.active,
            byDefault: true,
        },
        {
            text: 'Paused',
            value: MigrationSnipeStatusEnum.paused,
            byDefault: true,
        },
        {
            text: 'Finished',
            value: MigrationSnipeStatusEnum.finished,
            byDefault: true,
        },
        {
            text: 'Archived',
            value: MigrationSnipeStatusEnum.archived,
        },
    ],
    step: [
        {
            text: 'Created',
            value: MigrationSnipeWizardStepEnum.created,
        },
        {
            text: 'Validation',
            value: MigrationSnipeWizardStepEnum.validation,
        },
        {
            text: 'Completed',
            value: MigrationSnipeWizardStepEnum.completed,
        },
    ],
};
